import * as React from 'react';
import { color } from '@haldi/style-guide';
import classnames from 'classnames';

import { HaldiStickyNote } from '@src/routes/common/components/HaldiStickyNote';

import styles from './styles.module.css';

export interface AboutPeopleProps {
  className?: string;
}

/**
 * @name AboutPeople
 * @description A quick blurbs about the "people driven" approach Haldi takes.
 */
export const AboutPeople = (props: AboutPeopleProps) => {
  const { className } = props;

  // Styles
  const cssComponent = classnames(`bg-forest`, styles.component, className);
  const cssHeading = classnames('about-heading', styles.heading);
  const cssLeft = classnames('ui-desktop-', styles.left);
  const cssReflow = classnames('flex flex-col', styles.reflow);

  return (
    <div className={cssComponent}>
      <div className="ui-container-lg relative">
        <h2 className={cssHeading}>
          <span className="text-turmeric">No bots. No sales people.</span>
          <br />
          <span className="text-white">Just people people.</span>
        </h2>
        <div className={cssReflow}>
          <div className={cssLeft}>
            <HaldiStickyNote
              className={styles.sticky}
              fill={color.turmeric}
              flipped={true}
            >
              <div className="text-24 lg:p-2x lg:text-32">
                Team Haldi is
                <br />
                what makes us
                <br />
                who we are
              </div>
            </HaldiStickyNote>
          </div>
          <div className="text-white">
            <p>
              We are not bots, or salespeople, or derms. If you need a derm,
              we’ll be the first to tell you—please go see one! But if you’re
              overwhelmed by the idea of navigating the clutter of the skincare
              world, we’re your people. We’re skincare nerds who test every
              product obsessively and read the latest-and-greatest ingredients
              as our bedtime reading.
            </p>
            <p>
              Our skin coaches are here to listen, empathize, and ensure your
              routine is right for you.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
